var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconReplicateStoreCheck = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 42,
  viewBox: "0 0 45 42",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M39.2308 4.66667H2.30769V0H39.2308V4.66667ZM29.2846 23.3333H25.3846V27.2767C23.9308 29.4933 23.0769 32.13 23.0769 35C23.0769 35.7933 23.1692 36.5633 23.2846 37.3333H2.30769V23.3333H0V18.6667L2.30769 7H39.2308L41.5385 18.6667V21.8167C40.0846 21.3033 38.5385 21 36.9231 21C34.0846 21 31.4769 21.8633 29.2846 23.3333ZM20.7692 23.3333H6.92308V32.6667H20.7692V23.3333ZM42.3231 27.6267L34.0385 36.0033L30.3692 32.2933L27.6923 35L34.0385 42L45 30.9167L42.3231 27.6267Z",
  fill: "#949494"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconReplicateStoreCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_replicate_store_check.cd7663b9.svg";
export { ForwardRef as ReactComponent };